var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ApiProperty } from '@nestjs/swagger-v4';
import { Expose, Type } from 'class-transformer';
import { TemplateExposeGroup } from '../interface';
import { ReadTemplateCohortConfigParamDto } from './ReadTemplateCohortConfigParamDto';
export class ReadTemplateCohortConfigDto {
}
__decorate([
    ApiProperty({ description: 'Cohort template ID', example: '9eaa1d82-0b48-452e-baec-a00361937d67', type: () => String }),
    Expose({
        groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG],
    }),
    __metadata("design:type", String)
], ReadTemplateCohortConfigDto.prototype, "cohortTemplateId", void 0);
__decorate([
    ApiProperty({ description: 'If cohort template is default', example: true, type: () => Boolean }),
    Expose({
        groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG],
    }),
    __metadata("design:type", Boolean)
], ReadTemplateCohortConfigDto.prototype, "isDefault", void 0);
__decorate([
    ApiProperty({ description: 'If cohort template is used to search in user table', example: true, type: () => Boolean }),
    Expose({
        groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG],
    }),
    __metadata("design:type", Boolean)
], ReadTemplateCohortConfigDto.prototype, "usersOnly", void 0);
__decorate([
    ApiProperty({ description: 'List of campaign template cohort config param.', type: () => ReadTemplateCohortConfigParamDto, isArray: true }),
    Expose({
        groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG],
    }),
    Type(() => ReadTemplateCohortConfigParamDto),
    __metadata("design:type", Array)
], ReadTemplateCohortConfigDto.prototype, "params", void 0);
//# sourceMappingURL=ReadTemplateCohortConfigDto.js.map